import { useQuery } from '@tanstack/react-query';

import { apiRequest } from '../api';
import { queryKeys } from '../queryKeys';
import type { Stats } from '../types';

export function useStats() {
  return useQuery({
    queryKey: queryKeys.stats,
    queryFn: () => apiRequest<Stats>('/api/stats'),
  });
}
